import { Link } from './company/link.model';


export class QuickLink {
  id: number | string;
  link: Partial<Link>;
  label: string;
  href?: string;
  order: number;
  hidden?: boolean;
  isValid?: boolean;

  constructor(data: Partial<QuickLink> = {}) {
    this.id = data.id || null;
    this.href = data.href || null;
    this.label = data.label || null;
    this.order = data.order || null;
    this.hidden = data.hidden || false;
    this.isValid = data.isValid || false;
  }
}
